export default {
  body: {
    cmpt: {
      type: 'CActivityNew'
    }
  }
}
